import { render } from "./Error403.vue?vue&type=template&id=0e93a35c&ts=true"
import script from "./Error403.vue?vue&type=script&lang=ts"
export * from "./Error403.vue?vue&type=script&lang=ts"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__